module.exports = function () {
	return /^\d+(\.|-)\d+(\.|-)preview\.\S+$/.test(window.location.host);
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/utils/is-preview-mode.js
// module id = 34
// module chunks = 4